import { flatten } from 'flat';

const isEmptyObject = (o: unknown) =>
  typeof o === 'object' && o !== null && Object.keys(o).length === 0;

export function toQueryParams(source: object): string {
  const flatSource = flatten<object, { [key: string]: unknown }>(source, {
    delimiter: '.',
    maxDepth: Infinity,
    safe: false,
    transformKey: (k) => encodeURIComponent(k),
  });
  const queryParams = Object.keys(flatSource)
    .map((key) =>
      isEmptyObject(flatSource[key]) || typeof flatSource[key] === 'undefined'
        ? undefined
        : `${key}=${encodeURIComponent(`${flatSource[key]}`)}`
    )
    .filter((v) => typeof v === 'string');
  if (!queryParams.length) {
    return '';
  }

  return `?${queryParams.join('&')}`;
}
